import Vue from 'vue';
import { VTooltip } from 'v-tooltip';
import { VueMasonryPlugin } from 'vue-masonry';
// import VueCompositionAPI from '@vue/composition-api';
import VueGtag from 'vue-gtag';
import App from './App';
import router from './router';
import store from './store';

import './assets/styles/main.scss';
import './components/_globals';
import './filters/_globals';
import './mixins/_globals';

// Import config files
import './config';

let gtagID = 'G-FLSDD56JEQ';
if (document.URL.includes('umarketingcenter')) {
  gtagID = 'G-332X4T4TBV';
}


Vue.use(VueGtag, {
  config: { id: gtagID },
});


Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

// Vue Init
Vue.use(VueMasonryPlugin);
// Vue.use(VueCompositionAPI);
Vue.directive('tooltip', VTooltip);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
